export default function (current) {
  let start = 2018
  let year = []
  if (current >= start) {
    for (let i = start; i <= current; i++) {
      year.push(i.toString())
    }
  }
  return year
}



// WEBPACK FOOTER //
// ./src/assets/js/year.js